import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { SingleDropdownComponent } from '../../../../../../shared/components/dropdowns/single-dropdown/single-dropdown.component';
import { InputFieldComponent } from '../../../../../../shared/components/input-field/input-field.component';
import { numberCast } from '../../../../../../shared/functions/sectionCasters.function';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import {
	VEHICLE_EMISSIONS_UNIT_CO2,
	VEHICLE_FUEL_CONSUMPTION_UNIT,
} from '../../../translations/vehicles-select-items';

@Component({
	selector: 'app-vehicles-emissions',
	templateUrl: 'vehicles-emissions.component.html',
	imports: [
		ReactiveFormsModule,
		SingleDropdownComponent,
		InputFieldComponent,
		SectionWrapperComponent,
	],
})
export class VehiclesEmissionsComponent extends BaseSectionComponent<VehicleRecordModel> {
	protected _skipCount: number = 0;

	emissionsUnitCO2 = VEHICLE_EMISSIONS_UNIT_CO2;
	fuelConsumptionUnit = VEHICLE_FUEL_CONSUMPTION_UNIT;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			averageEmissionsCO2: [null],
			emissionsUnitCO2: [null],
			averageFuelConsumption: [null],
			fuelConsumptionUnit: [null],
			// computed: [null], -->  this will be added once it will be provided from BE
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			averageEmissionsCO2: this.recordData().averageEmissionsCO2,
			emissionsUnitCO2: this.recordData().emissionsUnitCO2,
			averageFuelConsumption: this.recordData().averageFuelConsumption,
			fuelConsumptionUnit: this.recordData().fuelConsumptionUnit,
			// computed: --> this.recordData().computed, this will be added once it will be provided from BE
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			averageEmissionsCO2: numberCast(
				this.detailsForm.value.averageEmissionsCO2,
			),
			emissionsUnitCO2: this.detailsForm.value.emissionsUnitCO2,
			averageFuelConsumption: numberCast(
				this.detailsForm.value.averageFuelConsumption,
			),
			fuelConsumptionUnit: this.detailsForm.value.fuelConsumptionUnit,
			// computed: -->  this.detailsForm.value.computed, this will be added once it will be provided from BE
		};
	}
}
